import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calls_warning_green",
  "use": "icon-calls_warning_green-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-calls_warning_green\"><clipPath id=\"icon-calls_warning_green_a\"><path d=\"m0 0h20v20h-20z\" /></clipPath><g clip-path=\"url(#icon-calls_warning_green_a)\" fill=\"#4bd214\"><path d=\"m10 19.166c-5.055 0-9.167-4.112-9.167-9.167s4.112-9.167 9.167-9.167 9.166 4.113 9.166 9.168c0 5.054-4.111 9.166-9.166 9.166zm0-16.666c-4.136 0-7.5 3.364-7.5 7.5 0 4.135 3.364 7.5 7.5 7.5s7.5-3.365 7.5-7.5c0-4.136-3.364-7.5-7.5-7.5z\" /><path d=\"m10 11.666c-.46 0-.833-.373-.833-.833v-5c0-.46.373-.833.833-.833s.833.373.833.833v5c0 .46-.373.833-.833.833z\" /><path d=\"m10 15c.69 0 1.25-.56 1.25-1.25s-.56-1.25-1.25-1.25-1.25.56-1.25 1.25.56 1.25 1.25 1.25z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/calls_warning_green.svg
// module id = Epzk
// module chunks = 87